// extracted by mini-css-extract-plugin
export default {"health_container":"Health-condition-page_health_container__W6J8e"};